import * as Sentry from '@sentry/browser';
const HEROKU_APP_NAME = process.env.REACT_APP_HEROKU_APP_NAME;
const HEROKU_RELEASE_VERSION = process.env.REACT_APP_HEROKU_RELEASE_VERSION;
const BUILD_NUMBER =
  HEROKU_APP_NAME && HEROKU_RELEASE_VERSION
    ? `${HEROKU_APP_NAME}-${HEROKU_RELEASE_VERSION}`
    : 'localhost';
const ENVIRONMENT = process.env.NODE_ENV;
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

const initSentry = () => {
  if (SENTRY_DSN)
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: ENVIRONMENT,
      release: `${BUILD_NUMBER}-client`,
    });
};

const getSentry = () => Sentry ?? null;

export { getSentry, initSentry };
